import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { ResRobotFetchTrip, ResRobotStopLocation, ResRobotTrip } from '../../schedule.model';
import { SchedulePartialStoreState } from '../schedule.reducer';
import { PlannerActions } from './planner.action';
import * as PlannerSelector from './planner.selectors';

@Injectable()
export class PlannerFacade {
    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: PlannerActions) {}

    origins$: Observable<any> = this.store.select(PlannerSelector.getOriginResults);
    destinations$: Observable<any> = this.store.select(PlannerSelector.getDestinationResults);

    selectedOrigin$: Observable<any> = this.store.select(PlannerSelector.getSelectedOrigin);
    selectedDestination$: Observable<any> = this.store.select(PlannerSelector.getSelectedDestination);

    trips$: Observable<ResRobotTrip[]> = this.store.select(PlannerSelector.getTrips);
    tripsLoading$: Observable<boolean> = this.store.select(PlannerSelector.getTripsLoading);
    selectedTripId$: Observable<number> = this.store.select(PlannerSelector.getSelectedTripId);
    selectedTrip$: Observable<any> = this.store.select(PlannerSelector.getSelectedTrip);
    selectedDate$: Observable<Date> = this.store.select(PlannerSelector.getSelectedDate);
    selectedPriority$: Observable<number> = this.store.select(PlannerSelector.getSelectedPriority);

    searchOrigin(stopName: string) {
        return this.store.dispatch(this.actions.fetchOriginList(stopName));
    }

    searchDestination(stopName: string) {
        return this.store.dispatch(this.actions.fetchDestinationList(stopName));
    }

    setOrigin(stop: ResRobotStopLocation) {
        return this.store.dispatch(this.actions.setOrigin(stop));
    }

    setDestination(stop: ResRobotStopLocation) {
        return this.store.dispatch(this.actions.setDestination(stop));
    }

    setDate(date: Date) {
        return this.store.dispatch(this.actions.setDate(date));
    }

    setPriority(priority: number) {
        return this.store.dispatch(this.actions.setPriority(priority));
    }

    fetchTrip(trip: ResRobotFetchTrip) {
        return this.store.dispatch(this.actions.fetchTrip(trip));
    }

    setSelectedTripId(tripId) {
        return this.store.dispatch(this.actions.setSelectedTripId(tripId));
    }

    resetPlanner() {
        this.store.dispatch(this.actions.resetPlanner());
    }

    getTripLatLngs(trip: ResRobotTrip): number[][] {
        const latLngs = [[Number(trip.LegList.Leg[0].Origin.lat), Number(trip.LegList.Leg[0].Origin.lon)]];

        trip.LegList.Leg.forEach((leg) => {
            if (leg.Stops && leg.Stops.Stop) {
                leg.Stops.Stop.forEach((stop) => {
                    latLngs.push([Number(stop.lat), Number(stop.lon)]);
                });
            } else {
                latLngs.push([Number(leg.Destination.lat), Number(leg.Destination.lon)]);
            }
        });

        return latLngs;
    }

    resetTrips() {
        return this.store.dispatch(this.actions.resetTrips());
    }
}
